<template>
    <video width="100%" height="100%" autoplay loop controls>
        <source :src="src" type="video/mp4">
      </video>
</template>
<script>
export default {
  props: ["src"],
  data: () => ({
    publicPath: process.env.BASE_URL
  })
};
</script>